export const QA_TURNSTILE_WIDGET_ID = 'alumni_v2_qna';

export const FC_ACADEMY_THUMBNAIL = 'https://d2beiqkhq929f0.cloudfront.net/'
  + 'public_assets/assets/000/078/019/original/'
  + 'academy.webp?1718289768';

export const FC_DSML_THUMBNAIL = 'https://d2beiqkhq929f0.cloudfront.net/'
  + 'public_assets/assets/000/078/020/original/'
  + 'dsml.webp?1718289782';

export const FC_DSML_VIDEO_LINK = 'https://d2beiqkhq929f0.cloudfront.net/'
  + 'event_videos/speakerIntroDsml.mp4';

export const FC_ACADEMY_VIDEO_LINK = 'https://d2beiqkhq929f0.cloudfront.net/'
  + 'public_assets/assets/000/070/585/original/'
  + 'SpeakerIntroAcademy.mp4?1712558229';

export const PLACEMENT_BANNER_LINK = `https://d2beiqkhq929f0.cloudfront.net/`
  + `public_assets/assets/000/085/083/original/Scaler`
  + `_Career_Transition_Assesment_Report_-_Combined_%281%29`
  + `_compressed_%282%29.pdf?1722925170`;

export const allowedAdvancedFilters = [
  'pre_scaler_role',
  'pre_academy_company',
  'college',
  'role',
  'post_academy_segment',
  'experience',
  'growth',
];

export const AdvancedfiltersNameMapping = {
  pre_scaler_role: 'Current Role',
  pre_academy_company: 'Current Company',
  college: 'College',
  role: 'Target Role',
  post_academy_segment: 'Target Company',
  experience: 'Experience',
  growth: 'Salary Hike',
};

export const defaultAdvancedOptions = {
  college: ['VIT Vellore', 'BITS Pilani'],
  pre_scaler_role: [
    'Student/Fresher',
    'Non Tech',
    'Other Engineering Role',
  ],
  role: ['SDE1'],
  pre_academy_company: ['TCS'],
  post_academy_segment: [
    'High Growth Startups',
    'Established Businesses',
    'Tech Giants',
  ],
};
